import React from 'react';

interface InputFieldProps {
    type: 'text' | 'email' | 'textarea' | 'number' | 'tel';
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    label: string;
    required?: boolean;
    rows?: number;
}

const InputField: React.FC<InputFieldProps> = ({ type, name, value, onChange, label, required, rows }) => {
    return (
        <div className='mb-4'>
            <label htmlFor={name} className='block text-sm font-normal text-lightGrey'>
                {label}
            </label>
            {type === 'textarea' ? (
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    rows={rows || 4}
                    className='mt-1 block w-full px-4 py-2 border-b border-grey bg-transparent resize-none'
                    required={required}
                />
            ) : (
                <input
                    id={name}
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="mt-1 block w-full px-4 py-2 border-b border-grey bg-transparent focus:border-white"
                    required={required}
                />
            )}
        </div>
    );
};

export default InputField;
